// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.calendar-wrapper {
  padding-bottom: 15px;
}
/* single page detail */
.calendar-event-detail-wrapper .calendar-event-detail-title {
  font-size: 18px;
  padding: 10px 0;
}
.calendar-event-detail-wrapper .calendar-event-location,
.calendar-event-detail-wrapper .calendar-event-contact,
.calendar-event-detail-wrapper .calendar-event-detail-description {
  padding: 10px 0;
}
/* main widget container */
.calendar {
  /*color: @calendar-color-5;*/
  margin: 0;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  position: relative;
}
.calendar button {
  padding: 5px 10px;
  font-size: 12px;
  line-height: 1.5;
  border-radius: 3px;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  touch-action: manipulation;
  cursor: pointer;
  -webkit-user-select: none;
  background-image: none;
  border: 1px solid transparent;
  -webkit-appearance: button;
}
.btn-grid-view,
.btn-list-view,
.btn-calendar-prev,
.btn-calendar-next {
  background-color: #5bc0de;
  color: white;
}
.btn-grid-view:hover,
.btn-list-view:hover,
.btn-calendar-prev:hover,
.btn-calendar-next:hover {
  background-color: #31b0d5;
  border-color: #269abc;
}
/* Button to reset to current month */
.btn-calendar-reset {
  float: right;
  background-color: #fff;
  color: #333;
}
.btn-calendar-reset:hover {
  background-color: #e6e6e6;
  border-color: #adadad;
}
/* wrapper for left button to make the clickable area bigger */
.btn-calendar-prev,
.btn-calendar-next {
  position: relative;
  width: 25px;
  height: 25px;
  color: white;
  padding: 0 !important;
}
.btn-calendar-prev {
  order: 1 !important;
}
.btn-calendar-prev:before {
  content: "";
  display: block;
  position: absolute;
  top: 4px;
  left: 0;
  border-right: 7px solid white;
  border-bottom: 7px solid transparent;
  border-top: 7px solid transparent;
  border-left: 7px solid transparent;
}
.btn-calendar-next {
  order: 3 !important;
}
.btn-calendar-next:before {
  content: "";
  display: block;
  position: absolute;
  top: 4px;
  right: 0;
  border-left: 7px solid white;
  border-bottom: 7px solid transparent;
  border-top: 7px solid transparent;
  border-right: 7px solid transparent;
}
/* Contains title & nav */
.calendar-header {
  float: left;
  clear: left;
  width: 100%;
  position: relative;
  box-sizing: border-box;
}
.calendar-header h4 {
  margin: 0;
  border-bottom: 1px solid white;
  padding: 5px 10px;
  text-align: left;
}
.calendar-controls {
  position: relative;
  /*float: left;
    width: 100%; */
  text-align: left;
  padding: 5px;
  background-color: #398AB7;
}
.calendar-controls > button {
  margin: 0 5px;
}
.calendar-date-display {
  position: relative;
  float: left;
  clear: left;
  width: 100%;
  padding: 5px 0;
  background-color: white;
  color: black;
  font-weight: bold;
  font-size: medium;
  display: flex;
  align-items: center;
  justify-content: center;
}
.calendar-header-title {
  font-size: 0.8em;
  text-transform: uppercase;
  order: 2;
  padding: 0 25px;
  width: 125px;
}
/* Day of the week headings */
.calendar-day-title-wrap {
  display: table;
  width: 100%;
  color: #a3a3a3;
  background: #fff;
  padding: 2px 0;
  border-bottom: 1px solid #EBEBEB;
}
.calendar-day-title-wrap div {
  width: 14.28% !important;
  display: table-cell;
  box-sizing: border-box;
  position: relative;
  font-weight: bold;
  text-align: center;
  text-transform: uppercase;
  font-size: 11px;
}
/* Calendar days wrapper */
.calendar-day-wrap {
  width: 100%;
  overflow: hidden;
}
.calendar-week {
  width: 100%;
}
/* Calendar Days */
.calendar-day,
.calendar-day-blank {
  width: 14.28% !important;
  max-width: 14.28% !important;
  display: inline-block;
  vertical-align: top;
  box-sizing: border-box;
  position: relative;
  font-weight: bold;
  color: black;
  background: #fff;
  box-shadow: 0 0 0 1px #EBEBEB;
  -webkit-transition: 0.25s;
  transition: 0.25s;
  padding: 0;
  text-decoration: none;
}
/* Trick to make the days' width equal their height */
.calendar-day:before {
  content: "";
  display: block;
  padding-top: 100%;
  float: left;
}
/* Hover effect for non event calendar days */
.calendar-day-wrap > a:hover {
  background: #A1C2E3;
}
/* Days that are part of previous or next month */
.calendar-day-blank {
  background: #F3F3F5;
}
/* Event calendar day number styles */
.calendar-day-event > .calendar-day-number {
  position: absolute;
  line-height: 1em;
  top: 2px;
  left: 2px;
  font-size: 11px;
}
/* Non-Event calendar day number styles */
.calendar-day-pick > .calendar-day-number {
  line-height: 1em;
  font-size: 11px;
  padding-top: 35%;
}
.calendar-day-pick > .calendar-indicator-wrap {
  margin: 0;
}
/* Days in the past in "picker" mode */
.calendar-past-day:after {
  content: '';
  width: 150%;
  height: 2px;
  -webkit-transform-origin: left top;
  -ms-transform-origin: left top;
  transform-origin: left top;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
  background: rgba(0, 0, 0, 0.1);
  position: absolute;
  left: 0;
  top: 0;
}
.calendar-past-day:hover {
  background: #fff !important;
}
/* Current day style */
.calendar-today .calendar-day-number {
  color: #FFF;
  background: #398AB7;
  top: 0;
  left: 0;
  font-size: 12px;
  line-height: 15px;
  padding: 2px 5px;
  text-align: center;
}
.calendar-day-pick.calendar-today .calendar-day-number {
  padding: 0;
  margin: 22% 22% 0 22%;
}
/* Button to return to month view */
.calendar-cal {
  position: absolute;
  top: 0;
  right: 0;
}
/* Wrapper around events */
.calendar-indicator-wrap {
  position: relative;
  text-align: center;
  line-height: 0;
  max-width: 20px;
  margin: 0 auto;
  padding-top: 40%;
}
/* Event indicator dots */
.calendar-day .calendar-event-indicator {
  display: inline-block;
  margin: 1px;
  width: 8px;
  height: 8px;
  vertical-align: middle;
  border-radius: 6px;
  background: #7BA7CE;
  font-size: 0;
  color: transparent;
}
.calendar-day .calendar-event-indicator:hover {
  cursor: pointer;
}
/* Listing of events under calendar */
.calendar-event-list {
  background: #FAFAFA;
  overflow: auto;
  position: absolute;
  top: 80px;
  width: 100%;
  height: calc(100% -  80px);
  -webkit-transition: 0.25s;
  transition: 0.25s;
  -webkit-transform: scale(0);
  -ms-transform: scale(0);
  transform: scale(0);
}
.calendar-event-list.active {
  transition: all 0.25s;
  -webkit-transform: scale(1);
  -ms-transform: scale(1);
  transform: scale(1);
}
.calendar-event-list .calendar-list-view-prior {
  text-align: center;
  cursor: pointer;
  color: black;
}
.calendar-event-detail {
  background: white;
  overflow-x: hidden;
  overflow-y: auto;
  position: absolute;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 25px 10px 0;
  top: 80px;
  width: 100%;
  height: calc(100% -  80px);
  -webkit-transition: 0.25s;
  transition: 0.25s;
  -webkit-transform: scale(0);
  -ms-transform: scale(0);
  transform: scale(0);
}
.calendar-event-detail.active {
  transition: all 0.25s;
  -webkit-transform: scale(1);
  -ms-transform: scale(1);
  transform: scale(1);
}
.calendar-event-detail .calendar-event-detail-close {
  position: absolute;
  top: 5px;
  right: 5px;
  width: 20px;
  height: 20px;
  border-radius: 3px;
  background-color: #b9513e;
  color: white;
  text-align: center;
  cursor: pointer;
}
.calendar-event-detail .calendar-event-detail-close:hover {
  opacity: 0.75;
  box-shadow: none;
}
.calendar-event-detail .calendar-event-detail-close:after {
  content: "X";
}
.calendar-event-detail .calendar-event-detail-title {
  font-size: 20px;
  font-weight: bold;
}
.calendar-event-detail .calendar-event-detail-time {
  color: #a3a3a3;
  font-size: 14px;
}
.calendar-event-detail .calendar-event-contact,
.calendar-event-detail .calendar-event-location,
.calendar-event-detail .calendar-event-url {
  font-size: 14px;
}
.calendar-event-detail .calendar-event-detail-description {
  color: black;
  font-size: 16px;
  margin: 15px 0;
}
/* Days in Events List */
.calendar-list-item-close {
  position: absolute;
  top: -15px;
  right: -15px;
  height: 35px;
  width: 35px;
  border-radius: 50%;
  background-color: #398AB7;
}
.calendar-list-item-close:after {
  content: "X";
}
.calendar-list-item {
  position: relative;
  padding: 10px 10px 5px 50px;
  display: none;
  border-top: 1px solid #D6D6D6;
  text-align: left;
}
.calendar-list-item:after {
  content: 'No Events';
  padding: 4px 10px;
  display: block;
  margin-bottom: 5px;
}
.calendar-event-list .calendar-today .calendar-event-list-date {
  background-color: #398AB7;
  font-weight: bold;
  font-size: small;
  color: white;
  padding: 5px;
}
/* Events in Events List */
.calendar-event-list .listed-event {
  display: block;
  background-color: rgba(255, 255, 255, 0.5);
  padding: 4px 10px;
  margin: 1px 3px;
  cursor: pointer;
}
.calendar-event-list .listed-event > span {
  font-weight: bold;
  text-transform: uppercase;
}
.calendar-event-list .listed-event.prior-date {
  display: none;
}
.calendar-list-item a:link,
.calendar-list-item a:visited {
  text-decoration: none;
}
.item-has-event {
  display: block;
}
.item-has-event:after {
  display: none !important;
}
.calendar-event-list-date {
  width: 50px;
  position: absolute;
  left: 0;
  top: 13px;
  text-align: center;
  font-size: 12px;
  font-weight: bold;
  line-height: 1.2em;
}
.calendar-list-time-start,
.calendar-list-time-end {
  font-size: 0.8em;
  /*display: inline-block;*/
  color: #a3a3a3;
}
.calendar-list-time-start:not(:empty):after {
  /*content:' -';
	padding-right:5px;*/
}
.calendar-deep-link {
  float: right;
}
/* Events List custom webkit scrollbar */
.calendar-event-list::-webkit-scrollbar {
  width: 9px;
}
/* Track */
.calendar-event-list::-webkit-scrollbar-track {
  background: none;
}
/* Handle */
.calendar-event-list::-webkit-scrollbar-thumb {
  background: #ccc;
  border: 1px solid #E9EBEC;
  border-radius: 10px;
}
.calendar-event-list::-webkit-scrollbar-thumb:hover {
  background: #555;
}
/* Increase font & spacing over larger size */
@media (min-width: 400px) {
  .calendar-day-number {
    top: 5px;
    left: 5px;
    font-size: 13px;
  }
}
/* Styles for large mode where text is revealed within events */
@media (min-width: 600px) {
  .calendar-day-event {
    padding-top: 20px;
  }
  .calendar-day-event:before {
    padding-top: 77%;
  }
  .calendar-day-event > .calendar-indicator-wrap {
    width: auto;
    max-width: none;
  }
  .calendar-indicator-wrap {
    padding: 0;
  }
  .calendar-day .calendar-event-indicator {
    display: block;
    margin: 0 0 1px 0;
    width: auto;
    padding: 4px;
    border-radius: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #fff;
    text-shadow: 0 0 2px rgba(0, 0, 0, 0.2);
    text-decoration: none;
    /*line-height: 1em;*/
    white-space: nowrap;
    box-sizing: border-box;
  }
  .calendar-event-title {
    height: 20px;
    padding: 7px 5px !important;
    font-size: 10px !important;
  }
}
/* ADD TO CALENDAR PLUGIN STYLE */
/**
 * AddToCalendar Blue Style
 * http://addtocalendar.com
 */
/* Base */
.addtocalendar var {
  display: none;
}
.addtocalendar {
  position: relative;
  display: block;
}
.addtocalendar.btn {
  display: inline-block !important;
}
.atcb-link {
  display: block;
  outline: none !important;
  cursor: pointer;
  color: #ffffff;
}
.atcb-link:hover {
  color: white;
  text-decoration: none;
}
.atcb-link:focus ~ ul,
.atcb-link:active ~ ul,
.atcb-list:hover {
  visibility: visible;
}
.atcb-list {
  visibility: hidden;
  position: absolute;
  top: 100%;
  left: 0;
  width: 170px;
  border: 1px solid lightgray;
  z-index: 900;
}
.atcb-list,
.atcb-item {
  list-style: none;
  margin: 0;
  padding: 0;
  background: #fff;
}
.atcb-item {
  float: none;
  text-align: left;
}
.atcb-item-link {
  text-decoration: none;
  outline: none;
  display: block;
  padding: 5px;
}
.atcb-item.hover,
.atcb-item:hover {
  position: relative;
  z-index: 900;
  cursor: pointer;
  text-decoration: none;
  outline: none;
}
/* Blue */
.atc-style-blue .atcb-link,
.atc-style-blue .atcb-link:hover,
.atc-style-blue .atcb-link:active,
.atc-style-blue .atcb-link:focus {
  margin: 0;
  padding: 7px 25px;
  color: #fff;
  font-family: "Verdana";
  font-size: 14px;
  text-decoration: none;
  outline: none;
  line-height: 20px;
  vertical-align: middle;
  background: #4281f4;
  box-shadow: 0 0 40px rgba(0, 0, 0, 0.13) inset;
  border-radius: 4px;
  zoom: 1;
}
.atc-style-blue .atcb-list {
  width: 170px;
  border: 1px solid #bababa;
  border-radius: 2px;
  box-shadow: 0 0 5px #AAA;
}
.atc-style-blue .atcb-list,
.atc-style-blue .atcb-item {
  background: #fff;
  color: #000;
}
.atc-style-blue .atcb-item,
.atc-style-blue .atcb-item-link {
  line-height: 1.3em;
  vertical-align: middle;
  zoom: 1;
}
.atc-style-blue .atcb-item-link,
.atc-style-blue .atcb-item-link:hover,
.atc-style-blue .atcb-item-link:active,
.atc-style-blue .atcb-item-link:focus {
  color: #000;
  font-family: "Verdana";
  font-size: 14px;
  text-decoration: none;
  outline: none;
  padding: 5px 15px;
}
.atc-style-blue .atcb-item-link:hover,
.atc-style-blue .atcb-item-link:active,
.atc-style-blue .atcb-item-link:focus {
  color: #fff;
}
.atc-style-blue .atcb-item.hover,
.atc-style-blue .atcb-item:hover {
  background: #4281f4;
}
/*# sourceMappingURL=port-calendar.css.map */`, "",{"version":3,"sources":["webpack://./port-calendar.less","webpack://./wwwroot/css/components/port-calendar.less"],"names":[],"mappings":"AAkBA;EACI,oBAAA;ACjBJ;AACA,uBAAuB;ADqBvB;EAEQ,eAAA;EACA,eAAA;ACpBR;ADiBA;;;EASQ,eAAA;ACrBR;AACA,0BAA0B;ADyB1B;ECvBE,4BAA4B;EDyB1B,SAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,iBAAA;EACA,kBAAA;ACvBJ;ADgBA;EAUQ,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,0BAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,6BAAA;EACA,0BAAA;ACvBR;AD2BA;;;;EAII,yBAAA;EACA,YAAA;ACzBJ;AD2BI;;;;EACI,yBAAA;EACA,qBAAA;ACtBR;AACA,qCAAqC;AD0BrC;EACI,YAAA;EACA,sBAAA;EACA,WAAA;ACxBJ;AD0BI;EACI,yBAAA;EACA,qBAAA;ACxBR;AACA,8DAA8D;AD4B9D;;EAEI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,qBAAA;AC1BJ;AD6BA;EACI,mBAAA;AC3BJ;AD6BI;EACI,WAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;EACA,6BAAA;EACA,oCAAA;EACA,iCAAA;EACA,kCAAA;AC3BR;AD+BA;EACI,mBAAA;AC7BJ;AD+BI;EACI,WAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;EACA,QAAA;EACA,4BAAA;EACA,oCAAA;EACA,iCAAA;EACA,mCAAA;AC7BR;AACA,yBAAyB;ADiCzB;EACI,WAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;AC/BJ;AD0BA;EAQQ,SAAA;EACA,8BAAA;EACA,iBAAA;EACA,gBAAA;AC/BR;ADmCA;EACI,kBAAA;ECjCF;kBACgB;EDmCd,gBAAA;EACA,YAAA;EACA,yBAAA;ACjCJ;AD2BA;EASQ,aAAA;ACjCR;ADqCA;EACI,kBAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,cAAA;EACA,uBAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;ACnCJ;ADsCA;EACI,gBAAA;EACA,yBAAA;EACA,QAAA;EACA,eAAA;EACA,YAAA;ACpCJ;AACA,6BAA6B;ADuC7B;EACI,cAAA;EACA,WAAA;EACA,cAAA;EACA,gBAAA;EACA,cAAA;EACA,gCAAA;ACrCJ;ADwCI;EACI,wBAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;ACtCR;AACA,0BAA0B;ADyC1B;EACI,WAAA;EACA,gBAAA;ACvCJ;AD0CA;EACI,WAAA;ACxCJ;AACA,kBAAkB;AD0ClB;;EACI,wBAAA;EACA,4BAAA;EACA,qBAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;EACA,6BAAA;EACA,yBAAA;EACA,iBAAA;EACA,UAAA;EACA,qBAAA;ACvCJ;AACA,qDAAqD;AD0CjD;EACI,WAAA;EACA,cAAA;EACA,iBAAA;EACA,WAAA;ACxCR;AACA,6CAA6C;AD2C7C;EACI,mBAAA;ACzCJ;AACA,iDAAiD;AD4CjD;EACI,mBAAA;AC1CJ;AACA,qCAAqC;AD6CrC;EACI,kBAAA;EACA,gBAAA;EACA,QAAA;EACA,SAAA;EACA,eAAA;AC3CJ;AACA,yCAAyC;ADiDrC;EACI,gBAAA;EACA,eAAA;EACA,gBAAA;AC/CR;ADkDI;EACI,SAAA;AChDR;AACA,sCAAsC;ADmDtC;EACI,WAAA;EACA,WAAA;EACA,WAAA;EACA,kCAAA;EACA,8BAAA;EACA,0BAAA;EACA,gCAAA;EACA,4BAAA;EACA,wBAAA;EACA,8BAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;ACjDJ;ADoDA;EACI,2BAAA;AClDJ;AACA,sBAAsB;ADoDtB;EACI,WAAA;EACA,mBAAA;EACA,MAAA;EACA,OAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AClDJ;ADqDA;EACI,UAAA;EACA,qBAAA;ACnDJ;AACA,mCAAmC;ADwDnC;EACI,kBAAA;EACA,MAAA;EACA,QAAA;ACtDJ;AACA,0BAA0B;ADyD1B;EACI,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;ACvDJ;AACA,yBAAyB;AD0DzB;EACI,qBAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EAEA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;ACzDJ;AD4DI;EACI,eAAA;AC1DR;AACA,qCAAqC;AD4DrC;EACI,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,0BAAA;EACA,yBAAA;EACA,iBAAA;EACA,2BAAA;EACA,uBAAA;EACA,mBAAA;AC1DJ;AD4DI;EACI,qBAAA;EACA,2BAAA;EACA,uBAAA;EACA,mBAAA;AC1DR;ADyCA;EAqBQ,kBAAA;EACA,eAAA;EACA,YAAA;AC3DR;AD+DA;EACI,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,2BAAA;EACA,8BAAA;EACA,sBAAA;EACA,oBAAA;EACA,SAAA;EACA,WAAA;EACA,0BAAA;EACA,yBAAA;EACA,iBAAA;EACA,2BAAA;EACA,uBAAA;EACA,mBAAA;AC7DJ;AD+DI;EACI,qBAAA;EACA,2BAAA;EACA,uBAAA;EACA,mBAAA;AC7DR;ADuCA;EA0BQ,kBAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AC9DR;ADgEQ;EACI,aAAA;EACA,gBAAA;AC9DZ;ADiEQ;EACI,YAAA;AC/DZ;ADoBA;EAgDQ,eAAA;EACA,iBAAA;ACjER;ADgBA;EAqDQ,cAAA;EACA,eAAA;AClER;ADYA;;;EA4DQ,eAAA;ACnER;ADOA;EAgEQ,YAAA;EACA,eAAA;EACA,cAAA;ACpER;AACA,wBAAwB;ADwExB;EACI,kBAAA;EACA,UAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;ACtEJ;ADyEI;EACI,YAAA;ACvER;AD0EA;EACI,kBAAA;EACA,2BAAA;EACA,aAAA;EACA,6BAAA;EACA,gBAAA;ACxEJ;AD2EI;EACI,oBAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;ACzER;AD4EA;EACI,yBAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,YAAA;AC1EJ;AACA,0BAA0B;AD6E1B;EACI,cAAA;EACA,0CAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;AC3EJ;ADsEA;EAQQ,iBAAA;EACA,yBAAA;AC3ER;AD8EI;EACI,aAAA;AC5ER;ADgFA;;EACI,qBAAA;AC7EJ;ADgFA;EACI,cAAA;AC9EJ;ADiFI;EACI,wBAAA;AC/ER;ADkFA;EACI,WAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AChFJ;ADmFA;;EAEI,gBAAA;ECjFF,yBAAyB;EDmFvB,cAAA;ACjFJ;ADoFI;EClFF;oBACkB;AACpB;ADqFA;EACI,YAAA;ACnFJ;AACA,wCAAwC;ADuFxC;EACI,UAAA;ACrFJ;AACA,UAAU;ADwFV;EACI,gBAAA;ACtFJ;AACA,WAAW;ADyFX;EACI,gBAAA;EACA,yBAAA;EACA,mBAAA;ACvFJ;AD0FI;EACI,gBAAA;ACxFR;AACA,6CAA6C;AD2F7C;EACI;IACI,QAAA;IACA,SAAA;IACA,eAAA;ECzFN;AACF;AACA,+DAA+D;AD2F/D;EACI;IACI,iBAAA;ECzFN;ED4FM;IACI,gBAAA;EC1FV;ED6FM;IACI,WAAA;IACA,eAAA;EC3FV;ED8FE;IACI,UAAA;EC5FN;ED+FE;IACI,cAAA;IACA,iBAAA;IACA,WAAA;IACA,YAAA;IACA,gBAAA;IACA,gBAAA;IACA,uBAAA;IACA,WAAA;IACA,uCAAA;IACA,qBAAA;IC7FJ,oBAAoB;ID+FhB,mBAAA;IACA,sBAAA;EC7FN;EDgGE;IACI,YAAA;IACA,2BAAA;IACA,0BAAA;EC9FN;AACF;AACA,iCAAiC;AACjC;;;EAGE;AACF,SAAS;ADmGT;EACI,aAAA;ACjGJ;ADoGA;EACI,kBAAA;EACA,cAAA;AClGJ;ADqGI;EACI,gCAAA;ACnGR;ADsGA;EACI,cAAA;EACA,wBAAA;EACA,eAAA;EACA,cAAA;ACpGJ;ADuGI;EACI,YAAA;EACA,qBAAA;ACrGR;ADwGI;;;EAGI,mBAAA;ACtGR;ADyGA;EACI,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,YAAA;EACA,2BAAA;EACA,YAAA;ACvGJ;AD0GA;;EAEI,gBAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;ACxGJ;AD2GA;EACI,WAAA;EACA,gBAAA;ACzGJ;AD4GA;EACI,qBAAA;EACA,aAAA;EACA,cAAA;EACA,YAAA;AC1GJ;AD6GA;;EAEI,kBAAA;EACA,YAAA;EACA,eAAA;EACA,qBAAA;EACA,aAAA;AC3GJ;AACA,SAAS;ADgHT;;;;EAII,SAAA;EACA,iBAAA;EACA,WAAA;EACA,sBAAA;EACA,eAAA;EACA,qBAAA;EACA,aAAA;EACA,iBAAA;EACA,sBAAA;EACA,mBAAA;EACA,8CAAA;EACA,kBAAA;EACA,OAAA;AC9GJ;ADiHA;EACI,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,wBAAA;AC/GJ;ADkHA;;EAEI,gBAAA;EACA,WAAA;AChHJ;ADmHA;;EAEI,kBAAA;EACA,sBAAA;EACA,OAAA;ACjHJ;ADoHI;;;;EAII,WAAA;EACA,sBAAA;EACA,eAAA;EACA,qBAAA;EACA,aAAA;EACA,iBAAA;AClHR;ADqHQ;;;EAGI,WAAA;ACnHZ;ADsHI;;EAEI,mBAAA;ACpHR;AACA,4CAA4C","sourcesContent":["@import \"./variables.less\";\n\n@color-1: rgb(17,104,162);\n@color-2: rgb(104,198,232);\n\n@gray-text: #a3a3a3;\n@port-shipping: rgb(185,81,62);\n\n@calendar-color-1: #398AB7;\n@calendar-color-2: @color-2;\n@calendar-color-3: #F3F3F5;\n@calendar-color-4: #FAFAFA;\n@calendar-color-5: @gray-text;\n@calendar-color-6: @color-1;\n@calendar-color-7: @port-shipping;\n@calendar-border-color-1: #e3e3e3;\n@calendar-header-height: 80px;\n\n.calendar-wrapper {\n    padding-bottom: 15px;\n}\n\n\n/* single page detail */\n.calendar-event-detail-wrapper {\n    .calendar-event-detail-title {\n        font-size: 18px;\n        padding: 10px 0;\n    }\n\n    .calendar-event-location,\n    .calendar-event-contact,\n    .calendar-event-detail-description {\n        padding: 10px 0;\n    }\n}\n\n/* main widget container */\n.calendar {\n    /*color: @calendar-color-5;*/\n    margin: 0;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    position: relative;\n\n    button {\n        padding: 5px 10px;\n        font-size: 12px;\n        line-height: 1.5;\n        border-radius: 3px;\n        font-weight: normal;\n        text-align: center;\n        white-space: nowrap;\n        vertical-align: middle;\n        touch-action: manipulation;\n        cursor: pointer;\n        -webkit-user-select: none;\n        background-image: none;\n        border: 1px solid transparent;\n        -webkit-appearance: button;\n    }\n}\n\n.btn-grid-view,\n.btn-list-view,\n.btn-calendar-prev,\n.btn-calendar-next {\n    background-color: #5bc0de;\n    color: white;\n\n    &:hover {\n        background-color: #31b0d5;\n        border-color: #269abc;\n    }\n}\n\n/* Button to reset to current month */\n.btn-calendar-reset {\n    float: right;\n    background-color: #fff;\n    color: #333;\n\n    &:hover {\n        background-color: #e6e6e6;\n        border-color: #adadad;\n    }\n}\n\n/* wrapper for left button to make the clickable area bigger */\n.btn-calendar-prev,\n.btn-calendar-next {\n    position: relative;\n    width: 25px;\n    height: 25px;\n    color: white;\n    padding: 0 !important;\n}\n\n.btn-calendar-prev {\n    order: 1 !important;\n\n    &:before {\n        content: \"\";\n        display: block;\n        position: absolute;\n        top: 4px;\n        left: 0;\n        border-right: 7px solid white;\n        border-bottom: 7px solid transparent;\n        border-top: 7px solid transparent;\n        border-left: 7px solid transparent;\n    }\n}\n\n.btn-calendar-next {\n    order: 3 !important;\n\n    &:before {\n        content: \"\";\n        display: block;\n        position: absolute;\n        top: 4px;\n        right: 0;\n        border-left: 7px solid white;\n        border-bottom: 7px solid transparent;\n        border-top: 7px solid transparent;\n        border-right: 7px solid transparent;\n    }\n}\n\n/* Contains title & nav */\n.calendar-header {\n    float: left;\n    clear: left;\n    width: 100%;\n    position: relative;\n    box-sizing: border-box;\n\n    h4 {\n        margin: 0;\n        border-bottom: 1px solid white;\n        padding: 5px 10px;\n        text-align: left;\n    }\n}\n\n.calendar-controls {\n    position: relative;\n    /*float: left;\n    width: 100%; */\n    text-align: left;\n    padding: 5px;\n    background-color: @calendar-color-1;\n\n    > button {\n        margin: 0 5px;\n    }\n}\n\n.calendar-date-display {\n    position: relative;\n    float: left;\n    clear: left;\n    width: 100%;\n    padding: 5px 0;\n    background-color: white;\n    color: black;\n    font-weight: bold;\n    font-size: medium;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.calendar-header-title {\n    font-size: .8em;\n    text-transform: uppercase;\n    order: 2;\n    padding: 0 25px;\n    width: 125px;\n}\n\n/* Day of the week headings */\n.calendar-day-title-wrap {\n    display: table;\n    width: 100%;\n    color: @calendar-color-5;\n    background: #fff;\n    padding: 2px 0;\n    border-bottom: 1px solid #EBEBEB;\n}\n\n    .calendar-day-title-wrap div {\n        width: 14.28% !important;\n        display: table-cell;\n        box-sizing: border-box;\n        position: relative;\n        font-weight: bold;\n        text-align: center;\n        text-transform: uppercase;\n        font-size: 11px;\n    }\n\n/* Calendar days wrapper */\n.calendar-day-wrap {\n    width: 100%;\n    overflow: hidden;\n}\n\n.calendar-week {\n    width: 100%;\n}\n/* Calendar Days */\n.calendar-day, .calendar-day-blank {\n    width: 14.28% !important;\n    max-width: 14.28% !important;\n    display: inline-block;\n    vertical-align: top;\n    box-sizing: border-box;\n    position: relative;\n    font-weight: bold;\n    color: black;\n    background: #fff;\n    box-shadow: 0 0 0 1px #EBEBEB;\n    -webkit-transition: .25s;\n    transition: .25s;\n    padding: 0;\n    text-decoration: none;\n}\n\n    /* Trick to make the days' width equal their height */\n    .calendar-day:before {\n        content: \"\";\n        display: block;\n        padding-top: 100%;\n        float: left;\n    }\n\n/* Hover effect for non event calendar days */\n.calendar-day-wrap > a:hover {\n    background: #A1C2E3;\n}\n\n/* Days that are part of previous or next month */\n.calendar-day-blank {\n    background: #F3F3F5;\n}\n\n/* Event calendar day number styles */\n.calendar-day-event > .calendar-day-number {\n    position: absolute;\n    line-height: 1em;\n    top: 2px;\n    left: 2px;\n    font-size: 11px;\n}\n\n/* Non-Event calendar day number styles */\n.calendar-day-pick {\n}\n\n    .calendar-day-pick > .calendar-day-number {\n        line-height: 1em;\n        font-size: 11px;\n        padding-top: 35%;\n    }\n\n    .calendar-day-pick > .calendar-indicator-wrap {\n        margin: 0;\n    }\n\n/* Days in the past in \"picker\" mode */\n.calendar-past-day:after {\n    content: '';\n    width: 150%;\n    height: 2px;\n    -webkit-transform-origin: left top;\n    -ms-transform-origin: left top;\n    transform-origin: left top;\n    -webkit-transform: rotate(45deg);\n    -ms-transform: rotate(45deg);\n    transform: rotate(45deg);\n    background: rgba(0, 0, 0, 0.1);\n    position: absolute;\n    left: 0;\n    top: 0;\n}\n\n.calendar-past-day:hover {\n    background: #fff !important;\n}\n/* Current day style */\n.calendar-today .calendar-day-number {\n    color: #FFF;\n    background: @calendar-color-1;\n    top: 0;\n    left: 0;\n    font-size: 12px;\n    line-height: 15px;\n    padding: 2px 5px;\n    text-align: center;\n}\n\n.calendar-day-pick.calendar-today .calendar-day-number {\n    padding: 0;\n    margin: 22% 22% 0 22%;\n}\n\n\n\n/* Button to return to month view */\n.calendar-cal {\n    position: absolute;\n    top: 0;\n    right: 0;\n}\n\n/* Wrapper around events */\n.calendar-indicator-wrap {\n    position: relative;\n    text-align: center;\n    line-height: 0;\n    max-width: 20px;\n    margin: 0 auto;\n    padding-top: 40%;\n}\n\n/* Event indicator dots */\n.calendar-day .calendar-event-indicator {\n    display: inline-block;\n    margin: 1px;\n    width: 8px;\n    height: 8px;\n    border-radius: 6px;\n    vertical-align: middle;\n    border-radius: 6px;\n    background: #7BA7CE;\n    font-size: 0;\n    color: transparent;\n}\n\n    .calendar-day .calendar-event-indicator:hover {\n        cursor: pointer;\n    }\n/* Listing of events under calendar */\n.calendar-event-list {\n    background: @calendar-color-4;\n    overflow: auto;\n    position: absolute;\n    top: @calendar-header-height;\n    width: 100%;\n    height: calc(~'100% - ' @calendar-header-height);\n    -webkit-transition: .25s;\n    transition: .25s;\n    -webkit-transform: scale(0);\n    -ms-transform: scale(0);\n    transform: scale(0);\n\n    &.active {\n        transition: all .25s;\n        -webkit-transform: scale(1);\n        -ms-transform: scale(1);\n        transform: scale(1);\n    }\n\n    .calendar-list-view-prior {\n        text-align: center;\n        cursor: pointer;\n        color: black;\n    }\n}\n\n.calendar-event-detail {\n    background: white;\n    overflow-x: hidden;\n    overflow-y: auto;\n    position: absolute;\n    -moz-box-sizing: border-box;\n    -webkit-box-sizing: border-box;\n    box-sizing: border-box;\n    padding: 25px 10px 0;\n    top: @calendar-header-height;\n    width: 100%;\n    height: calc(~'100% - ' @calendar-header-height);\n    -webkit-transition: .25s;\n    transition: .25s;\n    -webkit-transform: scale(0);\n    -ms-transform: scale(0);\n    transform: scale(0);\n\n    &.active {\n        transition: all .25s;\n        -webkit-transform: scale(1);\n        -ms-transform: scale(1);\n        transform: scale(1);\n    }\n\n    .calendar-event-detail-close {\n        position: absolute;\n        top: 5px;\n        right: 5px;\n        width: 20px;\n        height: 20px;\n        border-radius: 3px;\n        background-color: @calendar-color-7;\n        color: white;\n        text-align: center;\n        cursor: pointer;\n\n        &:hover {\n            opacity: .75;\n            box-shadow: none;\n        }\n\n        &:after {\n            content: \"X\";\n        }\n    }\n\n    .calendar-event-detail-title {\n        font-size: 20px;\n        font-weight: bold;\n    }\n\n    .calendar-event-detail-time {\n        color: @calendar-color-5;\n        font-size: 14px;\n    }\n\n    .calendar-event-contact,\n    .calendar-event-location,\n    .calendar-event-url {\n        font-size: 14px;\n    }\n\n    .calendar-event-detail-description {\n        color: black;\n        font-size: 16px;\n        margin: 15px 0;\n    }\n}\n\n/* Days in Events List */\n.calendar-list-item-close {\n    position: absolute;\n    top: -15px;\n    right: -15px;\n    height: 35px;\n    width: 35px;\n    border-radius: 50%;\n    background-color: @calendar-color-1;\n}\n\n    .calendar-list-item-close:after {\n        content: \"X\";\n    }\n\n.calendar-list-item {\n    position: relative;\n    padding: 10px 10px 5px 50px;\n    display: none;\n    border-top: 1px solid #D6D6D6;\n    text-align: left;\n}\n\n    .calendar-list-item:after {\n        content: 'No Events';\n        padding: 4px 10px;\n        display: block;\n        margin-bottom: 5px;\n    }\n\n.calendar-event-list .calendar-today .calendar-event-list-date {\n    background-color: @calendar-color-1;\n    font-weight: bold;\n    font-size: small;\n    color: white;\n    padding: 5px;\n}\n\n/* Events in Events List */\n.calendar-event-list .listed-event {\n    display: block;\n    background-color: rgba(255,255,255,.5);\n    padding: 4px 10px;\n    margin: 1px 3px;\n    cursor: pointer;\n\n    > span {\n        font-weight: bold;\n        text-transform: uppercase;\n    }\n\n    &.prior-date {\n        display: none;\n    }\n}\n\n.calendar-list-item a:link, .calendar-list-item a:visited {\n    text-decoration: none;\n}\n\n.item-has-event {\n    display: block;\n}\n\n    .item-has-event:after {\n        display: none !important;\n    }\n\n.calendar-event-list-date {\n    width: 50px;\n    position: absolute;\n    left: 0;\n    top: 13px;\n    text-align: center;\n    font-size: 12px;\n    font-weight: bold;\n    line-height: 1.2em;\n}\n\n.calendar-list-time-start,\n.calendar-list-time-end {\n    font-size: .8em;\n    /*display: inline-block;*/\n    color: @calendar-color-5;\n}\n\n    .calendar-list-time-start:not(:empty):after {\n        /*content:' -';\n\tpadding-right:5px;*/\n    }\n\n.calendar-deep-link {\n    float: right;\n}\n\n/* Events List custom webkit scrollbar */\n\n.calendar-event-list::-webkit-scrollbar {\n    width: 9px;\n}\n\n/* Track */\n.calendar-event-list::-webkit-scrollbar-track {\n    background: none;\n}\n\n/* Handle */\n.calendar-event-list::-webkit-scrollbar-thumb {\n    background: #ccc;\n    border: 1px solid #E9EBEC;\n    border-radius: 10px;\n}\n\n    .calendar-event-list::-webkit-scrollbar-thumb:hover {\n        background: #555;\n    }\n\n/* Increase font & spacing over larger size */\n@media (min-width: 400px) {\n    .calendar-day-number {\n        top: 5px;\n        left: 5px;\n        font-size: 13px;\n    }\n}\n/* Styles for large mode where text is revealed within events */\n@media (min-width: 600px) {\n    .calendar-day-event {\n        padding-top: 20px;\n    }\n\n        .calendar-day-event:before {\n            padding-top: 77%;\n        }\n\n        .calendar-day-event > .calendar-indicator-wrap {\n            width: auto;\n            max-width: none;\n        }\n\n    .calendar-indicator-wrap {\n        padding: 0;\n    }\n\n    .calendar-day .calendar-event-indicator {\n        display: block;\n        margin: 0 0 1px 0;\n        width: auto;\n        padding: 4px;\n        border-radius: 0;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        color: #fff;\n        text-shadow: 0 0 2px rgba(0,0,0,.2);\n        text-decoration: none;\n        /*line-height: 1em;*/\n        white-space: nowrap;\n        box-sizing: border-box;\n    }\n\n    .calendar-event-title {\n        height: 20px;\n        padding: 7px 5px !important;\n        font-size: 10px !important;\n    }\n}\n\n/* ADD TO CALENDAR PLUGIN STYLE */\n/**\n * AddToCalendar Blue Style\n * http://addtocalendar.com\n */\n\n/* Base */\n\n.addtocalendar var {\n    display: none;\n}\n\n.addtocalendar {\n    position: relative;\n    display: block;\n}\n\n    .addtocalendar.btn {\n        display: inline-block !important;\n    }\n\n.atcb-link {\n    display: block;\n    outline: none !important;\n    cursor: pointer;\n    color: #ffffff;\n}\n\n    .atcb-link:hover {\n        color: white;\n        text-decoration: none;\n    }\n\n    .atcb-link:focus ~ ul,\n    .atcb-link:active ~ ul,\n    .atcb-list:hover {\n        visibility: visible;\n    }\n\n.atcb-list {\n    visibility: hidden;\n    position: absolute;\n    top: 100%;\n    left: 0;\n    width: 170px;\n    border: 1px solid lightgray;\n    z-index: 900;\n}\n\n.atcb-list,\n.atcb-item {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    background: #fff;\n}\n\n.atcb-item {\n    float: none;\n    text-align: left;\n}\n\n.atcb-item-link {\n    text-decoration: none;\n    outline: none;\n    display: block;\n    padding: 5px;\n}\n\n.atcb-item.hover,\n.atcb-item:hover {\n    position: relative;\n    z-index: 900;\n    cursor: pointer;\n    text-decoration: none;\n    outline: none;\n}\n\n\n/* Blue */\n\n.atc-style-blue .atcb-link,\n.atc-style-blue .atcb-link:hover,\n.atc-style-blue .atcb-link:active,\n.atc-style-blue .atcb-link:focus {\n    margin: 0;\n    padding: 7px 25px;\n    color: #fff;\n    font-family: \"Verdana\";\n    font-size: 14px;\n    text-decoration: none;\n    outline: none;\n    line-height: 20px;\n    vertical-align: middle;\n    background: rgb(66,129,244);\n    box-shadow: 0 0 40px rgba(0, 0, 0, .13) inset;\n    border-radius: 4px;\n    zoom: 1;\n}\n\n.atc-style-blue .atcb-list {\n    width: 170px;\n    border: 1px solid rgb(186,186,186);\n    border-radius: 2px;\n    box-shadow: 0 0 5px #AAA;\n}\n\n.atc-style-blue .atcb-list,\n.atc-style-blue .atcb-item {\n    background: #fff;\n    color: #000;\n}\n\n.atc-style-blue .atcb-item,\n.atc-style-blue .atcb-item-link {\n    line-height: 1.3em;\n    vertical-align: middle;\n    zoom: 1;\n}\n\n    .atc-style-blue .atcb-item-link,\n    .atc-style-blue .atcb-item-link:hover,\n    .atc-style-blue .atcb-item-link:active,\n    .atc-style-blue .atcb-item-link:focus {\n        color: #000;\n        font-family: \"Verdana\";\n        font-size: 14px;\n        text-decoration: none;\n        outline: none;\n        padding: 5px 15px;\n    }\n\n        .atc-style-blue .atcb-item-link:hover,\n        .atc-style-blue .atcb-item-link:active,\n        .atc-style-blue .atcb-item-link:focus {\n            color: #fff;\n        }\n\n    .atc-style-blue .atcb-item.hover,\n    .atc-style-blue .atcb-item:hover {\n        background: rgb(66,129,244);\n    }\n",".calendar-wrapper {\n  padding-bottom: 15px;\n}\n/* single page detail */\n.calendar-event-detail-wrapper .calendar-event-detail-title {\n  font-size: 18px;\n  padding: 10px 0;\n}\n.calendar-event-detail-wrapper .calendar-event-location,\n.calendar-event-detail-wrapper .calendar-event-contact,\n.calendar-event-detail-wrapper .calendar-event-detail-description {\n  padding: 10px 0;\n}\n/* main widget container */\n.calendar {\n  /*color: @calendar-color-5;*/\n  margin: 0;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  position: relative;\n}\n.calendar button {\n  padding: 5px 10px;\n  font-size: 12px;\n  line-height: 1.5;\n  border-radius: 3px;\n  font-weight: normal;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n  touch-action: manipulation;\n  cursor: pointer;\n  -webkit-user-select: none;\n  background-image: none;\n  border: 1px solid transparent;\n  -webkit-appearance: button;\n}\n.btn-grid-view,\n.btn-list-view,\n.btn-calendar-prev,\n.btn-calendar-next {\n  background-color: #5bc0de;\n  color: white;\n}\n.btn-grid-view:hover,\n.btn-list-view:hover,\n.btn-calendar-prev:hover,\n.btn-calendar-next:hover {\n  background-color: #31b0d5;\n  border-color: #269abc;\n}\n/* Button to reset to current month */\n.btn-calendar-reset {\n  float: right;\n  background-color: #fff;\n  color: #333;\n}\n.btn-calendar-reset:hover {\n  background-color: #e6e6e6;\n  border-color: #adadad;\n}\n/* wrapper for left button to make the clickable area bigger */\n.btn-calendar-prev,\n.btn-calendar-next {\n  position: relative;\n  width: 25px;\n  height: 25px;\n  color: white;\n  padding: 0 !important;\n}\n.btn-calendar-prev {\n  order: 1 !important;\n}\n.btn-calendar-prev:before {\n  content: \"\";\n  display: block;\n  position: absolute;\n  top: 4px;\n  left: 0;\n  border-right: 7px solid white;\n  border-bottom: 7px solid transparent;\n  border-top: 7px solid transparent;\n  border-left: 7px solid transparent;\n}\n.btn-calendar-next {\n  order: 3 !important;\n}\n.btn-calendar-next:before {\n  content: \"\";\n  display: block;\n  position: absolute;\n  top: 4px;\n  right: 0;\n  border-left: 7px solid white;\n  border-bottom: 7px solid transparent;\n  border-top: 7px solid transparent;\n  border-right: 7px solid transparent;\n}\n/* Contains title & nav */\n.calendar-header {\n  float: left;\n  clear: left;\n  width: 100%;\n  position: relative;\n  box-sizing: border-box;\n}\n.calendar-header h4 {\n  margin: 0;\n  border-bottom: 1px solid white;\n  padding: 5px 10px;\n  text-align: left;\n}\n.calendar-controls {\n  position: relative;\n  /*float: left;\n    width: 100%; */\n  text-align: left;\n  padding: 5px;\n  background-color: #398AB7;\n}\n.calendar-controls > button {\n  margin: 0 5px;\n}\n.calendar-date-display {\n  position: relative;\n  float: left;\n  clear: left;\n  width: 100%;\n  padding: 5px 0;\n  background-color: white;\n  color: black;\n  font-weight: bold;\n  font-size: medium;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.calendar-header-title {\n  font-size: 0.8em;\n  text-transform: uppercase;\n  order: 2;\n  padding: 0 25px;\n  width: 125px;\n}\n/* Day of the week headings */\n.calendar-day-title-wrap {\n  display: table;\n  width: 100%;\n  color: #a3a3a3;\n  background: #fff;\n  padding: 2px 0;\n  border-bottom: 1px solid #EBEBEB;\n}\n.calendar-day-title-wrap div {\n  width: 14.28% !important;\n  display: table-cell;\n  box-sizing: border-box;\n  position: relative;\n  font-weight: bold;\n  text-align: center;\n  text-transform: uppercase;\n  font-size: 11px;\n}\n/* Calendar days wrapper */\n.calendar-day-wrap {\n  width: 100%;\n  overflow: hidden;\n}\n.calendar-week {\n  width: 100%;\n}\n/* Calendar Days */\n.calendar-day,\n.calendar-day-blank {\n  width: 14.28% !important;\n  max-width: 14.28% !important;\n  display: inline-block;\n  vertical-align: top;\n  box-sizing: border-box;\n  position: relative;\n  font-weight: bold;\n  color: black;\n  background: #fff;\n  box-shadow: 0 0 0 1px #EBEBEB;\n  -webkit-transition: 0.25s;\n  transition: 0.25s;\n  padding: 0;\n  text-decoration: none;\n}\n/* Trick to make the days' width equal their height */\n.calendar-day:before {\n  content: \"\";\n  display: block;\n  padding-top: 100%;\n  float: left;\n}\n/* Hover effect for non event calendar days */\n.calendar-day-wrap > a:hover {\n  background: #A1C2E3;\n}\n/* Days that are part of previous or next month */\n.calendar-day-blank {\n  background: #F3F3F5;\n}\n/* Event calendar day number styles */\n.calendar-day-event > .calendar-day-number {\n  position: absolute;\n  line-height: 1em;\n  top: 2px;\n  left: 2px;\n  font-size: 11px;\n}\n/* Non-Event calendar day number styles */\n.calendar-day-pick > .calendar-day-number {\n  line-height: 1em;\n  font-size: 11px;\n  padding-top: 35%;\n}\n.calendar-day-pick > .calendar-indicator-wrap {\n  margin: 0;\n}\n/* Days in the past in \"picker\" mode */\n.calendar-past-day:after {\n  content: '';\n  width: 150%;\n  height: 2px;\n  -webkit-transform-origin: left top;\n  -ms-transform-origin: left top;\n  transform-origin: left top;\n  -webkit-transform: rotate(45deg);\n  -ms-transform: rotate(45deg);\n  transform: rotate(45deg);\n  background: rgba(0, 0, 0, 0.1);\n  position: absolute;\n  left: 0;\n  top: 0;\n}\n.calendar-past-day:hover {\n  background: #fff !important;\n}\n/* Current day style */\n.calendar-today .calendar-day-number {\n  color: #FFF;\n  background: #398AB7;\n  top: 0;\n  left: 0;\n  font-size: 12px;\n  line-height: 15px;\n  padding: 2px 5px;\n  text-align: center;\n}\n.calendar-day-pick.calendar-today .calendar-day-number {\n  padding: 0;\n  margin: 22% 22% 0 22%;\n}\n/* Button to return to month view */\n.calendar-cal {\n  position: absolute;\n  top: 0;\n  right: 0;\n}\n/* Wrapper around events */\n.calendar-indicator-wrap {\n  position: relative;\n  text-align: center;\n  line-height: 0;\n  max-width: 20px;\n  margin: 0 auto;\n  padding-top: 40%;\n}\n/* Event indicator dots */\n.calendar-day .calendar-event-indicator {\n  display: inline-block;\n  margin: 1px;\n  width: 8px;\n  height: 8px;\n  vertical-align: middle;\n  border-radius: 6px;\n  background: #7BA7CE;\n  font-size: 0;\n  color: transparent;\n}\n.calendar-day .calendar-event-indicator:hover {\n  cursor: pointer;\n}\n/* Listing of events under calendar */\n.calendar-event-list {\n  background: #FAFAFA;\n  overflow: auto;\n  position: absolute;\n  top: 80px;\n  width: 100%;\n  height: calc(100% -  80px);\n  -webkit-transition: 0.25s;\n  transition: 0.25s;\n  -webkit-transform: scale(0);\n  -ms-transform: scale(0);\n  transform: scale(0);\n}\n.calendar-event-list.active {\n  transition: all 0.25s;\n  -webkit-transform: scale(1);\n  -ms-transform: scale(1);\n  transform: scale(1);\n}\n.calendar-event-list .calendar-list-view-prior {\n  text-align: center;\n  cursor: pointer;\n  color: black;\n}\n.calendar-event-detail {\n  background: white;\n  overflow-x: hidden;\n  overflow-y: auto;\n  position: absolute;\n  -moz-box-sizing: border-box;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n  padding: 25px 10px 0;\n  top: 80px;\n  width: 100%;\n  height: calc(100% -  80px);\n  -webkit-transition: 0.25s;\n  transition: 0.25s;\n  -webkit-transform: scale(0);\n  -ms-transform: scale(0);\n  transform: scale(0);\n}\n.calendar-event-detail.active {\n  transition: all 0.25s;\n  -webkit-transform: scale(1);\n  -ms-transform: scale(1);\n  transform: scale(1);\n}\n.calendar-event-detail .calendar-event-detail-close {\n  position: absolute;\n  top: 5px;\n  right: 5px;\n  width: 20px;\n  height: 20px;\n  border-radius: 3px;\n  background-color: #b9513e;\n  color: white;\n  text-align: center;\n  cursor: pointer;\n}\n.calendar-event-detail .calendar-event-detail-close:hover {\n  opacity: 0.75;\n  box-shadow: none;\n}\n.calendar-event-detail .calendar-event-detail-close:after {\n  content: \"X\";\n}\n.calendar-event-detail .calendar-event-detail-title {\n  font-size: 20px;\n  font-weight: bold;\n}\n.calendar-event-detail .calendar-event-detail-time {\n  color: #a3a3a3;\n  font-size: 14px;\n}\n.calendar-event-detail .calendar-event-contact,\n.calendar-event-detail .calendar-event-location,\n.calendar-event-detail .calendar-event-url {\n  font-size: 14px;\n}\n.calendar-event-detail .calendar-event-detail-description {\n  color: black;\n  font-size: 16px;\n  margin: 15px 0;\n}\n/* Days in Events List */\n.calendar-list-item-close {\n  position: absolute;\n  top: -15px;\n  right: -15px;\n  height: 35px;\n  width: 35px;\n  border-radius: 50%;\n  background-color: #398AB7;\n}\n.calendar-list-item-close:after {\n  content: \"X\";\n}\n.calendar-list-item {\n  position: relative;\n  padding: 10px 10px 5px 50px;\n  display: none;\n  border-top: 1px solid #D6D6D6;\n  text-align: left;\n}\n.calendar-list-item:after {\n  content: 'No Events';\n  padding: 4px 10px;\n  display: block;\n  margin-bottom: 5px;\n}\n.calendar-event-list .calendar-today .calendar-event-list-date {\n  background-color: #398AB7;\n  font-weight: bold;\n  font-size: small;\n  color: white;\n  padding: 5px;\n}\n/* Events in Events List */\n.calendar-event-list .listed-event {\n  display: block;\n  background-color: rgba(255, 255, 255, 0.5);\n  padding: 4px 10px;\n  margin: 1px 3px;\n  cursor: pointer;\n}\n.calendar-event-list .listed-event > span {\n  font-weight: bold;\n  text-transform: uppercase;\n}\n.calendar-event-list .listed-event.prior-date {\n  display: none;\n}\n.calendar-list-item a:link,\n.calendar-list-item a:visited {\n  text-decoration: none;\n}\n.item-has-event {\n  display: block;\n}\n.item-has-event:after {\n  display: none !important;\n}\n.calendar-event-list-date {\n  width: 50px;\n  position: absolute;\n  left: 0;\n  top: 13px;\n  text-align: center;\n  font-size: 12px;\n  font-weight: bold;\n  line-height: 1.2em;\n}\n.calendar-list-time-start,\n.calendar-list-time-end {\n  font-size: 0.8em;\n  /*display: inline-block;*/\n  color: #a3a3a3;\n}\n.calendar-list-time-start:not(:empty):after {\n  /*content:' -';\n\tpadding-right:5px;*/\n}\n.calendar-deep-link {\n  float: right;\n}\n/* Events List custom webkit scrollbar */\n.calendar-event-list::-webkit-scrollbar {\n  width: 9px;\n}\n/* Track */\n.calendar-event-list::-webkit-scrollbar-track {\n  background: none;\n}\n/* Handle */\n.calendar-event-list::-webkit-scrollbar-thumb {\n  background: #ccc;\n  border: 1px solid #E9EBEC;\n  border-radius: 10px;\n}\n.calendar-event-list::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n/* Increase font & spacing over larger size */\n@media (min-width: 400px) {\n  .calendar-day-number {\n    top: 5px;\n    left: 5px;\n    font-size: 13px;\n  }\n}\n/* Styles for large mode where text is revealed within events */\n@media (min-width: 600px) {\n  .calendar-day-event {\n    padding-top: 20px;\n  }\n  .calendar-day-event:before {\n    padding-top: 77%;\n  }\n  .calendar-day-event > .calendar-indicator-wrap {\n    width: auto;\n    max-width: none;\n  }\n  .calendar-indicator-wrap {\n    padding: 0;\n  }\n  .calendar-day .calendar-event-indicator {\n    display: block;\n    margin: 0 0 1px 0;\n    width: auto;\n    padding: 4px;\n    border-radius: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    color: #fff;\n    text-shadow: 0 0 2px rgba(0, 0, 0, 0.2);\n    text-decoration: none;\n    /*line-height: 1em;*/\n    white-space: nowrap;\n    box-sizing: border-box;\n  }\n  .calendar-event-title {\n    height: 20px;\n    padding: 7px 5px !important;\n    font-size: 10px !important;\n  }\n}\n/* ADD TO CALENDAR PLUGIN STYLE */\n/**\n * AddToCalendar Blue Style\n * http://addtocalendar.com\n */\n/* Base */\n.addtocalendar var {\n  display: none;\n}\n.addtocalendar {\n  position: relative;\n  display: block;\n}\n.addtocalendar.btn {\n  display: inline-block !important;\n}\n.atcb-link {\n  display: block;\n  outline: none !important;\n  cursor: pointer;\n  color: #ffffff;\n}\n.atcb-link:hover {\n  color: white;\n  text-decoration: none;\n}\n.atcb-link:focus ~ ul,\n.atcb-link:active ~ ul,\n.atcb-list:hover {\n  visibility: visible;\n}\n.atcb-list {\n  visibility: hidden;\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: 170px;\n  border: 1px solid lightgray;\n  z-index: 900;\n}\n.atcb-list,\n.atcb-item {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  background: #fff;\n}\n.atcb-item {\n  float: none;\n  text-align: left;\n}\n.atcb-item-link {\n  text-decoration: none;\n  outline: none;\n  display: block;\n  padding: 5px;\n}\n.atcb-item.hover,\n.atcb-item:hover {\n  position: relative;\n  z-index: 900;\n  cursor: pointer;\n  text-decoration: none;\n  outline: none;\n}\n/* Blue */\n.atc-style-blue .atcb-link,\n.atc-style-blue .atcb-link:hover,\n.atc-style-blue .atcb-link:active,\n.atc-style-blue .atcb-link:focus {\n  margin: 0;\n  padding: 7px 25px;\n  color: #fff;\n  font-family: \"Verdana\";\n  font-size: 14px;\n  text-decoration: none;\n  outline: none;\n  line-height: 20px;\n  vertical-align: middle;\n  background: #4281f4;\n  box-shadow: 0 0 40px rgba(0, 0, 0, 0.13) inset;\n  border-radius: 4px;\n  zoom: 1;\n}\n.atc-style-blue .atcb-list {\n  width: 170px;\n  border: 1px solid #bababa;\n  border-radius: 2px;\n  box-shadow: 0 0 5px #AAA;\n}\n.atc-style-blue .atcb-list,\n.atc-style-blue .atcb-item {\n  background: #fff;\n  color: #000;\n}\n.atc-style-blue .atcb-item,\n.atc-style-blue .atcb-item-link {\n  line-height: 1.3em;\n  vertical-align: middle;\n  zoom: 1;\n}\n.atc-style-blue .atcb-item-link,\n.atc-style-blue .atcb-item-link:hover,\n.atc-style-blue .atcb-item-link:active,\n.atc-style-blue .atcb-item-link:focus {\n  color: #000;\n  font-family: \"Verdana\";\n  font-size: 14px;\n  text-decoration: none;\n  outline: none;\n  padding: 5px 15px;\n}\n.atc-style-blue .atcb-item-link:hover,\n.atc-style-blue .atcb-item-link:active,\n.atc-style-blue .atcb-item-link:focus {\n  color: #fff;\n}\n.atc-style-blue .atcb-item.hover,\n.atc-style-blue .atcb-item:hover {\n  background: #4281f4;\n}\n/*# sourceMappingURL=port-calendar.css.map */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
